import { createMiddleware } from "@tanstack/react-start";

export const ELEKTRYK_ADMIN_TOKEN_KEY = "elektryk_admin_token";

export const attachElektrykAdmin = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    if (typeof window === "undefined") return next();
    let token: string | null = null;
    try {
      token = window.localStorage.getItem(ELEKTRYK_ADMIN_TOKEN_KEY);
    } catch {
      token = null;
    }
    if (!token) return next();
    return next({
      headers: { "x-elektryk-admin": token },
    });
  },
);